import styled from 'styled-components';

export const WorkspaceItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const WorkspaceItemsTitle = styled.h3`
  margin: 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
`;

export const WorkspaceItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const WorkspaceItemRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background: #f5f5f5;
  }
`;

export const WorkspaceItemInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const WorkspaceItemActions = styled.div`
  display: flex;
  gap: 8px;
`;
